import React, { useContext, useState } from 'react'
import './index.scss'
import { NavLink, useNavigate } from 'react-router'
import Navigation from '@App/navigation'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { StoresContext } from '@App/contexts'

const UserMenu = () => {
    const [panelIsOpen, setPanelIsOpen] = useState(false)
    const [mouseOverPanel, setMouseOverPanel] = useState(false)
    const [loaderOpen, setLoaderOpen] = useState(false)
    const { userStore, authStore } = useContext(StoresContext)
    const navigate = useNavigate()

    const logOut = async () => {
        setLoaderOpen(true)
        try {
            await authStore.logOut()
        } catch {
            // Local logout has already completed, so a remote failure must not keep the user in the authenticated UI.
        } finally {
            setLoaderOpen(false)
            navigate(Navigation.login.root())
        }
    }

    const userInfo = userStore.userInfo
    const firstName = userInfo && userInfo.firstName
    const lastName = userInfo && userInfo.lastName
    const email = userInfo && userInfo.email
    const avatar = firstName && lastName ? `${firstName.substr(0, 1)}${lastName.substr(0, 1)}` : 'MLC'
    const classNames = ['user-menu-component', panelIsOpen ? 'active' : ''].join(' ')

    return (
        <div className={classNames} data-testid="user-menu-component" title="User Menu">
            <span className="bold">{avatar}</span>
            <label
                htmlFor="user-trigger"
                className="user-panel"
                title=""
                onMouseMove={() => setMouseOverPanel(true)}
                onMouseOut={() => setMouseOverPanel(false)}
            >
                <div className="user-info">
                    <div className="user-avatar">
                        <h3>{avatar}</h3>
                    </div>
                    <div className="user-details">
                        <p className="user-name" title={firstName + ' ' + lastName}>
                            {firstName} {lastName}
                        </p>
                        {email && (
                            <p className="user-email" title={email}>
                                {email}
                            </p>
                        )}
                    </div>
                </div>
                {loaderOpen ? (
                    <PointPreloader />
                ) : (
                    <div className="user-options">
                        <NavLink
                            className="notification-preferences-link"
                            to={Navigation.notification.preferences()}
                            onClick={() => setPanelIsOpen(false)}
                        >
                            Notification Preferences
                        </NavLink>
                        <NavLink
                            className="preferences-link"
                            to={Navigation.profile.root()}
                            onClick={() => setPanelIsOpen(false)}
                        >
                            Profile
                        </NavLink>
                        <p className="logout-link small" onClick={logOut}>
                            Log out
                        </p>
                    </div>
                )}
            </label>
            <input
                type="text"
                id="user-trigger"
                onBlur={() => setPanelIsOpen(mouseOverPanel)}
                onClick={() => setPanelIsOpen(true)}
                defaultChecked
            />
            <label className="user-trigger" htmlFor="user-trigger" />
        </div>
    )
}

export default UserMenu
